import { render, staticRenderFns } from "./CateringOrderLinkView.vue?vue&type=template&id=60e72879&scoped=true&"
import script from "./CateringOrderLinkView.vue?vue&type=script&lang=js&"
export * from "./CateringOrderLinkView.vue?vue&type=script&lang=js&"
import style0 from "./CateringOrderLinkView.vue?vue&type=style&index=0&id=60e72879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e72879",
  null
  
)

export default component.exports